import { Badge, BadgeColor, Button } from '@prishapolicy/shared/ui';
import { Dispatch, SetStateAction } from 'react';

export const SmallHorizontalCard = (props: {
  title: string;
  description: string;
  badges: { text: string; theme: BadgeColor }[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  image: any;
  idx: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
  // productType: string;
}) => {
  const setActiveIndex = props.setActiveIndex;
  const idx = props.idx;
  const Image = props.image;
  return (
    <div className="rounded-large border-grey-200 my-2 flex h-full flex-col justify-between border p-5 lg:my-0">
      <div className="flex gap-x-2">
        <div
          className="border-grey-100 rounded-large grid place-items-center border"
          style={{
            width: 70,
            height: 70,
          }}
        >
          <Image />
        </div>
        <div className="flex-1">
          <div className="flex">
            <h6 className="flex-1 break-words font-bold">{props.title}</h6>
          </div>
          <p className="text-grey-600 mt-0.5">{props.description}</p>
        </div>
      </div>
      <div>
        <div className="bg-grey-100 mb-2 h-px"></div>
        <div className="flex justify-between">
          <Button
            theme="primary"
            size="small"
            leftIcon="downloadLine"
            variant="secondary"
            type="submit"
            onClick={() => {
              setActiveIndex(idx);
            }}
            aria-label="Download"
          />
          <div className="flex gap-x-1">
            {props.badges.map((badge, idx) => {
              return <Badge key={idx} text={badge.text} theme={badge.theme} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallHorizontalCard;
